import { render, staticRenderFns } from "./TxnSummaryInteractingAddress.vue?vue&type=template&id=70409198&scoped=true&"
import script from "./TxnSummaryInteractingAddress.vue?vue&type=script&lang=ts&"
export * from "./TxnSummaryInteractingAddress.vue?vue&type=script&lang=ts&"
import style0 from "./TxnSummaryInteractingAddress.vue?vue&type=style&index=0&id=70409198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70409198",
  null
  
)

export default component.exports